import React, { createContext, useState } from 'react';

export const ScenarioContext = createContext();

export function ScenarioProvider({ children }) {
  const [messages, setMessages] = useState([]);
  return (
    <ScenarioContext.Provider value={{ messages, setMessages }}>
      {children}
    </ScenarioContext.Provider>
  );
}